export const DEFAULT_OPTIONS_COUNT = 6
export const OPTION_KEY_TITLE = 'nationalityName'
export const OPTION_KEY_VALUE = 'nationalityCode'
export const OPTION_KEY_SEARCH = 'searchString'
export const NATIONALITY_MASK = {
  value: 'S'.repeat(255),
  tokens: {
    S: { pattern: /[a-zA-Z\u0600-\u06FF\s]/ },
  },
}
